import { render, staticRenderFns } from "./SendMessageBox.vue?vue&type=template&id=553e1870&scoped=true&"
import script from "./SendMessageBox.vue?vue&type=script&lang=js&"
export * from "./SendMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageBox.vue?vue&type=style&index=0&id=553e1870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553e1870",
  null
  
)

export default component.exports